'use client'

import type { ContentLayout } from '@/helpers/layout'
import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

const ContentLayoutContext = createContext<ContentLayout>('wide')

type ContentLayoutProviderProps = {
	layout: ContentLayout
}

export const ContentLayoutProvider: FC<PropsWithChildren<ContentLayoutProviderProps>> = ({
	children,
	layout,
}) => {
	return <ContentLayoutContext.Provider value={layout}>{children}</ContentLayoutContext.Provider>
}

export const useContentLayout = () => useContext(ContentLayoutContext)
